import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import MuiLink from "@mui/material/Link";

export const SecondaryLink = ({ to, children }: { to: string; children: ReactNode }) => (
  <MuiLink
    component={RouterLink}
    to={to}
    underline="hover"
    sx={{
      "fontSize": theme => theme.typography.pxToRem(12),
      "color": theme => theme.palette.text.secondary,
      "&:hover": { color: theme => theme.palette.text.primary },
      "&:focus-visible": {
        outline: "2px solid",
        outlineColor: theme => theme.palette.primary.main,
        outlineOffset: "2px",
        borderRadius: "1px",
      },
    }}
  >
    {children}
  </MuiLink>
);
